import { useEffect } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import LoyaltyHero from './components/LoyaltyHero';
import LoyaltyLevels from './components/LoyaltyLevels';
import LoyaltyHowItWorks from './components/LoyaltyHowItWorks';
import LoyaltyCalculator from './components/LoyaltyCalculator';
import LoyaltyFaq from './components/LoyaltyFaq';
import LoyaltyCta from './components/LoyaltyCta';
import SeoHead, { SITE_URL } from '@/components/feature/SeoHead';

const loyaltyJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Программа лояльности NeonPharma — бонусная карта',
  description: 'Программа лояльности NeonPharma: накапливайте бонусные баллы, получайте скидки до 50%, кэшбэк 15%. Уровни: Старт, Серебро, Золото, Платина.',
  url: `${SITE_URL}/loyalty`,
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Программа лояльности', item: `${SITE_URL}/loyalty` },
    ],
  },
};

const LoyaltyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#050508' }}>
      <SeoHead
        title="Программа лояльности — бонусная карта NeonPharma | Кэшбэк 15%"
        description="Программа лояльности NeonPharma: накапливайте бонусные баллы за каждую покупку, получайте кэшбэк 15%, скидки до 50%. Уровни: Старт, Серебро, Золото, Платина."
        keywords="программа лояльности, бонусная карта аптека, кэшбэк, скидки NeonPharma"
        canonical="/loyalty"
        jsonLd={loyaltyJsonLd}
      />
      <Navbar />
      <LoyaltyHero />
      <LoyaltyLevels />
      <LoyaltyHowItWorks />
      <LoyaltyCalculator />
      <LoyaltyFaq />
      <LoyaltyCta />
      <Footer />
    </div>
  );
};

export default LoyaltyPage;
